<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Pagination from "@/router/layouts/table-pagination.vue";
import { debounce } from "@/helpers/debounce";
import axios from "axios";
import Swal from "sweetalert2";
import Datepicker from "vue3-datepicker";
import moment from "moment";
import $ from 'jquery';
import DataTable from "datatables.net-vue3"
import DataTablesCore from "datatables.net"
import 'datatables.net-fixedcolumns-dt'
DataTable.use(DataTablesCore);

export default {
    page: {
        title: "Pelaksanaan",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
        Pagination,
        Datepicker,
        DataTable
    },
    data() {
        let sortOrders = []; // select sortOrder

        // definisi kolom yang dipakai
        let columns = [
            { width: "auto", label: "No", name: "pbl_id" },
            { width: "auto", label: "Kode ", name: "pbl_kode" },
            { width: "auto", label: "Tanggal Mulai", name: "pbl_tgl_mulai" },
            { width: "auto", label: "Tanggal Selesai", name: "pbl_tgl_selesai" },
            {
                width: "auto",
                label: "Biaya Perencanaan",
                name: "pbl_tot_budget_plan",
            },
            {
                width: "auto",
                label: "Biaya Terkonfirmasi",
                name: "pbl_tot_budget_confirm",
            },
            { width: "auto", label: "Biaya Terealisasi", name: "pbl_tot_budget_fix" },
        ];

        // cek sorting
        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            title: "Data Pelaksanaan (Selesai)",
            items: [
                {
                    text: "Data Pelaksanaan (Selesai)",
                    active: true,
                },
            ],
            namePathUrl: this.$route.name,
            sessionRoleId: localStorage.session_role_active_id,

            // variable Page Table
            loadingTable: true,
            table_data: [],
            columns: columns,
            sortKey: "pbl_id", // sort key awal
            sortOrders: sortOrders,
            currentTablePage: "",

            // parsing data ke table data
            tableData: {
                draw: 0,
                length: 10,
                search: "",
                column: 0,
                dir: "asc",
                filter_status: "SEMUA DATA",
                filter_tanggal_mulai: null,
                filter_tanggal_selesai: null,
            },

            // config untuk paginasi
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
                links: "",
            },

            showFeedbackPeserta: false,
            feedback_peserta: {},

            dataDatatable: [],
            optionsDatatable: {
                paging: false,
                scrollCollapse: true,
                searching: false,
                info: false,
                ordering: false,
                processing: true,
                fixedColumns: {
                    left: 5
                },
                scrollY: "500px",
                scrollX: true,
                columns: [
                    { data: "no" },
                    { data: "pbl_kode" },
                    { data: "pbl_judul" },
                    { data: "pbl_tgl_mulai" },
                    { data: "pbl_tgl_selesai" },
                    { data: "pbl_durasi_he" },
                    { data: "pbl_durasi_jp" },
                    { data: "pbl_angkatan" },
                    // { data: "status_wo" },
                    { data: "status_peserta" },
                    // { data: "status_peserta_lms" },
                    { data: "status_instruktur" },
                    // { data: "status_materi" },
                    { data: "status_kehadiran" },
                    { data: "status_nilai" },
                    { data: "status_laporan" },
                    { data: "biaya_perencanaan" },
                    { data: "biaya_terkonfirmasi" },
                    { data: "biaya_terealisasi" },
                    {
                        data: "pbl_feedback",
                        render: function (data) {
                            var html = `<div class="d-grid gap-2">
                  <button
                  type="button"
                  class="btn btn-info btn-sm btn-block clickAble"
                  data-feedback="${data}"
                  id="button-feedback"
                  >
                      <i class="bx bx-check-square"></i> Lihat
                  </button>
              </div>`
                            return html;
                        }
                    },
                    { data: "status" },
                    {
                        data: "action",
                        render: function (row, key, index) {
                            var button_detail = `
                <div class="d-grid gap-2">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm btn-block"
                    data-id_encrypt_detail="${index['pbl_id_encrypt']}"
                    id="button-detail"
                  >
                    Detail
                  </button>

                  <button
                    type="button"
                    class="btn btn-success btn-sm btn-block"
                    data-id_encrypt_detail="${index['pbl_id_encrypt']}"
                    id="button-evaluasi-pasca-pelatihan"
                  >
                    Evaluasi Pasca Pelatihan
                  </button>
                </div>
              `;

                            let button_perbaikan = "";
                            let button_final = "";
                            if (index['status_pelaksanaan'] == 'BELUM DISELENGGARAKAN') {
                                button_perbaikan = `
                  <div class="d-grid gap-2">
                    <button
                      type="button"
                      class="btn btn-warning btn-sm btn-block"
                      data-id_encrypt_perbaiki="${index['pbl_id_encrypt']}"
                      id="button-perbaiki"
                    >
                      Pebaiki
                    </button>
                  </div>
                `;
                            }

                            if (index['btn_final_pelaksanaan'] == true) {
                                button_final = `
                  <div class="d-grid gap-2">
                    <button
                      type="button"
                      class="btn btn-success btn-sm btn-block"
                      data-id_encrypt_selesai="${index['pbl_id_encrypt']}"
                      id="button-selesai"
                    >
                      Konfirmasi Selesai
                    </button>
                  </div>
                `;
                            }
                            return button_detail + button_perbaikan + button_final;
                        }
                    }
                ]
            }
        };
    },
    created() {
        this.searchDatatable = debounce(() => {
            this.getDataTable();
            // call fetch API to get results
        }, 500);
    },
    mounted() {
        let self = this;
        self.cekAksesMenu();
        self.getDataTable();
        self.buttonTable();
    },
    methods: {
        buttonTable() {
            let self = this;
            $(document).on('click', '#button-feedback', function () {
                let feedback_data = $(this).data('feedback');
                self.feedbackPeserta(feedback_data);
            })

            $(document).on('click', '#button-detail', function () {
                let id_encrypt_detail = $(this).data('id_encrypt_detail');
                self.redirectDetail(id_encrypt_detail);
            })

            $(document).on('click', '#button-evaluasi-pasca-pelatihan', function () {
                let id_encrypt_detail = $(this).data('id_encrypt_detail');
                self.redirectEvaluasiPascaPelatihan(id_encrypt_detail);
            })

            $(document).on('click', '#button-perbaiki', function () {
                let id_encrypt_perbaiki = $(this).data('id_encrypt_perbaiki');
                self.changeStatusData('DRAFT', id_encrypt_perbaiki);
            })

            $(document).on('click', '#button-selesai', function () {
                let id_encrypt_selesai = $(this).data('id_encrypt_selesai');
                self.changeStatusData('FINAL', id_encrypt_selesai);
            })
        },
        redirectDetail(id_encrypt_detail) {
            this.$router.push({ name: 'detail-evaluasi', params: { id: id_encrypt_detail } })
        },
        redirectEvaluasiPascaPelatihan(id_encrypt_detail) {
            this.$router.push({ name: 'detail-evaluasi-pasca-pelatihan', params: { id: id_encrypt_detail } })
        },
        cekAksesMenu() {
            let self = this;
            var config_axios = {
                method: "get",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/check-access-menu",
                params: {
                    role_id: self.sessionRoleId,
                    link_name: self.namePathUrl,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config_axios)
                .then((response) => {
                    let response_data_fix = response.data.data.status_access;
                    if (response.data.meta.code == 200) {
                        if (response_data_fix == false) {
                            Swal.fire({
                                icon: "warning",
                                title: "Oppss",
                                text: "Mohon maaf anda tidak diberikan akses pada halaman ini.",
                                timer: 2000,
                                timerProgressBar: true,
                                showConfirmButton: false,
                            }).then((result) => {
                                /* Read more about handling dismissals below */
                                if (result.dismiss === Swal.DismissReason.timer) {
                                    self.$router.push({ name: "dashboard" });
                                }
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: response_data_fix.data.message,
                        });
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        getDataTable(
            url = process.env.VUE_APP_BACKEND_URL_VERSION +
                "transactions/pra-pelaksanaan"
        ) {
            let self = this;

            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading Data ...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            self.loadingTable = true;
            self.tableData.draw++;

            var config = {
                method: "get",
                url: url,
                params: self.tableData,
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config)
                .then((response) => {
                    let response_data = response.data;
                    let response_data_fix = response_data.data[0];
                    if (response_data.meta.code == 200) {
                        if (self.tableData.draw == response_data_fix.draw) {
                            self.table_data = response_data_fix.list_data.data;
                            self.dataDatatable = response_data_fix.res_pelaksanaan
                            self.configPagination(response_data_fix.list_data);
                            self.currentTablePage = response_data_fix.list_data.current_page;
                        }
                        self.loadingTable = false;
                        Swal.close();
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: response_data_fix.data.message,
                        });
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            let self = this;
            self.pagination.lastPage = data.last_page;
            self.pagination.currentPage = data.current_page;
            self.pagination.total = data.total;
            self.pagination.lastPageUrl = data.last_page_url;
            self.pagination.nextPageUrl = data.next_page_url;
            self.pagination.prevPageUrl = data.prev_page_url;
            self.pagination.from = data.from;
            self.pagination.to = data.to;
            self.pagination.links = data.links;
        },
        sortBy(key) {
            let self = this;
            self.sortKey = key;
            self.sortOrders[key] = self.sortOrders[key] * -1;
            self.tableData.column = self.getIndex(self.columns, "name", key);
            self.tableData.dir = self.sortOrders[key] === 1 ? "asc" : "desc";
            self.getDataTable();
        },
        getIndex(array, key, value) {
            return array.findIndex((i) => i[key] == value);
        },
        toPage: function (str) {
            let self = this;
            self.getDataTable(str);
        },
        changeStatusData(status, id) {
            let self = this;

            let text_alert = "";
            if (status == "DRAFT") {
                text_alert =
                    "Jika anda memperbaiki data permohonan ini maka Data Peserta dan Instruktur akan di reset ke status awal (Harus di undang kembali), anda yakin ingin mengubah status?";
            } else {
                text_alert = "Apakah anda yakin ingin mengubah status data tersebut?";
            }

            Swal.fire({
                title: "Perhatian",
                text: text_alert,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `Iya`,
                denyButtonText: `Tidak`,
            }).then((result) => {
                if (result.isConfirmed) {
                    self.loadingTable = true;
                    Swal.fire({
                        title: '<i class="fa fa-refresh fa-spin"></i>',
                        text: "Loading...",
                        showConfirmButton: false,
                    });

                    var config = {
                        method: "put",
                        url:
                            process.env.VUE_APP_BACKEND_URL_VERSION +
                            "transactions/pra-pelaksanaan",
                        data: {
                            id: id,
                            status: status,
                            user_id: localStorage.getItem("session_user_id"),
                        },
                        headers: {
                            Accept: "application/json",
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                    };
                    axios(config).then((response) => {
                        var response_data = response.data;
                        if (response_data.meta.code != "200") {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response_data.data.message,
                            });
                        } else {
                            Swal.fire({
                                icon: "success",
                                title: "Berhasil",
                                text: "Data berhasil diperbarui.",
                                timer: 2000,
                                timerProgressBar: true,
                                showCancelButton: false,
                                showConfirmButton: false,
                            }).then((result) => {
                                /* Read more about handling dismissals below */
                                if (result.dismiss === Swal.DismissReason.timer) {
                                    self.getDataTable();
                                    self.showAlat = false;
                                }
                            });
                        }
                    });
                } else {
                    Swal.close();
                }
            });
        },
        detailGI(dataGI) {
            this.dataGI = dataGI;
            this.showDetailGI = true;
        },
        resetFilter() {
            this.tableData.filter_tanggal_mulai = null;
            this.tableData.filter_tanggal_selesai = null;
            this.getDataTable();
        },
        number_format(number, decimals, decPoint, thousandsSep) {
            number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
            var n = !isFinite(+number) ? 0 : +number;
            var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
            var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
            var dec = typeof decPoint === "undefined" ? "." : decPoint;
            var s = "";

            var toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return "" + (Math.round(n * k) / k).toFixed(prec);
            };

            // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || "").length < prec) {
                s[1] = s[1] || "";
                s[1] += new Array(prec - s[1].length + 1).join("0");
            }

            return s.join(dec);
        },
        feedbackPeserta(feedback) {
            let self = this;
            self.feedback_peserta = feedback;
            self.showFeedbackPeserta = true;
        },
        exportExcelData() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading Ekspor Data ...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            var config = {
                method: "post",
                responseType: "arraybuffer",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "transactions/pra-pelaksanaan/export",
                data: {
                    filter_status: self.tableData.filter_status,
                    filter_tanggal_mulai: self.tableData.filter_tanggal_mulai,
                    filter_tanggal_selesai: self.tableData.filter_tanggal_selesai,
                },
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                    Accept: "application/vnd.ms-excel",
                },
            };

            axios(config).then(function (response) {
                if (response.data.meta?.code == 500) {
                    Swal.close();
                    Swal.fire({
                        icon: "warning",
                        title: "Oops...",
                        text: "Error, mohon coba lagi.",
                    });
                } else {
                    Swal.close();
                    const url = window.URL.createObjectURL(
                        new Blob([response.data], { type: "application/csv" })
                    );
                    // console.log(url);
                    const link = document.createElement("a");
                    link.href = url;
                    const timestamp = moment().format("YYYYMMDD_HHmmss");
                    link.setAttribute(
                        "download",
                        "export-pelaksanaan-pembelajaran-" + timestamp + ".xlsx"
                    );
                    document.body.appendChild(link);
                    link.click();
                }
            });
        }
    },
};


</script>
<style>
th {
    border-color: grey !important;
}

td {
    border-color: grey !important;
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-md-6">
                                <div class="card-title">Semua Data Pelaksanaan</div>
                            </div>
                            <div class="col-md-6">
                                <div class="d-flex justify-content-end mb-3">
                                    <div class="d-flex ps-2"></div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr />
                                <div class="row">
                                    <div class="form-group col-md-2">
                                        <label>Tanggal Mulai</label>
                                        <datepicker v-model="tableData.filter_tanggal_mulai" @update:model-value="getDataTable()" placeholder="Pilih tanggal mulai" clear-button class="form-control"></datepicker>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Tanggal Selesai</label>
                                        <datepicker v-model="tableData.filter_tanggal_selesai" @update:model-value="getDataTable()" placeholder="Pilih tanggal selesai" clear-button class="form-control"></datepicker>
                                    </div>
                                    <div class="form-group col-md-4" style="margin-top: 26px">
                                        <button type="button" @click="resetFilter()" class="btn btn-primary">
                                            <i class="fas fa-undo"></i> Reset
                                        </button>
                                        &nbsp;
                                        <button type="button" @click="exportExcelData()" class="btn btn-info">
                                            <i class="fas fa-file-excel"></i> Eksport Excel
                                        </button>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div class="col-md-12 mb-2">
                                <div class="row">
                                    <div class="col-md-4">
                                        <table>
                                            <tr>
                                                <td>Show</td>
                                                <td>
                                                    <select class="form-control form-control-sm" id="showpaginatetable" style="width: 100%" v-model="tableData.length" @change="getDataTable()">
                                                        <option value="10" selected>10</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="200">200</option>
                                                        <option value="500">500</option>
                                                    </select>
                                                </td>
                                                <td>Entries</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md-5">&nbsp;</div>
                                    <div class="col-md-3">
                                        <input type="text" class="form-control form-control-sm" id="searchTable" placeholder="Cari Data ..." v-model="tableData.search" @input="searchDatatable" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <DataTable :options="optionsDatatable" :data="dataDatatable" class="table display">
                                    <thead class="bg-dark text-center text-white">
                                        <tr>
                                            <th rowspan="2" style="width: 75px;cursor: pointer;vertical-align: middle;" @click="sortBy('pbl_id')">
                                                No
                                                <i :class="sortKey === 'pbl_id'
                                                    ? sortOrders['pbl_id'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                            <th rowspan="2" style="
                          width: 250px;
                          cursor: pointer;
                          vertical-align: middle;
                        " @click="sortBy('pbl_kode')">
                                                Kode
                                                <i :class="sortKey === 'pbl_kode'
                                                    ? sortOrders['pbl_kode'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                            <th rowspan="2" style="width: 700px; vertical-align: middle">
                                                Judul
                                            </th>
                                            <th rowspan="2" style="
                          width: 300px;
                          cursor: pointer;
                          vertical-align: middle;
                        " @click="sortBy('pbl_tgl_mulai')">
                                                Tanggal Mulai
                                                <i :class="sortKey === 'pbl_tgl_mulai'
                                                    ? sortOrders['pbl_tgl_mulai'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                            <th rowspan="2" style="
                          width: 300px;
                          cursor: pointer;
                          vertical-align: middle;
                        " @click="sortBy('pbl_tgl_selesai')">
                                                Tanggal Selesai
                                                <i :class="sortKey === 'pbl_tgl_selesai'
                                                    ? sortOrders['pbl_tgl_selesai'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                            <th rowspan="2" style="width: 50px; vertical-align: middle">
                                                Durasi HE
                                            </th>
                                            <th rowspan="2" style="width: 50px; vertical-align: middle">
                                                Durasi JP
                                            </th>
                                            <th rowspan="2" style="width: 100px; vertical-align: middle">
                                                Angkatan
                                            </th>
                                            <th colspan="2" style="width: 200px; vertical-align: middle">
                                                Pra
                                            </th>
                                            <th colspan="2" style="width: 200px; vertical-align: middle">
                                                Pelaksanaan
                                            </th>
                                            <th style="width: 200px; vertical-align: middle">
                                                Finalisasi
                                            </th>
                                            <th colspan="3" style="width: 200px">Total Biaya</th>
                                            <th style="width: 100px; vertical-align: middle" rowspan="2">
                                                Feedback
                                            </th>
                                            <th style="width: 100px; vertical-align: middle" rowspan="2">
                                                Status
                                            </th>
                                            <th style="width: 300px !important; vertical-align: middle" rowspan="2">
                                                Aksi
                                            </th>
                                        </tr>
                                        <tr>
                                            <!-- <th style="vertical-align: middle">WO</th> -->
                                            <th style="vertical-align: middle">Peserta</th>
                                            <!-- <th style="vertical-align: middle">Peserta LMS</th> -->
                                            <th style="vertical-align: middle">Instruktur</th>
                                            <!-- <th style="vertical-align: middle">Materi</th> -->
                                            <th style="vertical-align: middle">Kehadiran</th>
                                            <th style="vertical-align: middle">Nilai</th>
                                            <th style="vertical-align: middle">Laporan</th>
                                            <th style="cursor: pointer; vertical-align: middle" @click="sortBy('pbl_tot_budget_plan')">
                                                Perencanaan
                                                <i :class="sortKey === 'pbl_tot_budget_plan'
                                                    ? sortOrders['pbl_tot_budget_plan'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                            <th style="cursor: pointer; vertical-align: middle" @click="sortBy('pbl_tot_budget_confirm')">
                                                Terkonfirmasi
                                                <i :class="sortKey === 'pbl_tot_budget_confirm'
                                                    ? sortOrders['pbl_tot_budget_confirm'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                            <th style="cursor: pointer; vertical-align: middle" @click="sortBy('pbl_tot_budget_fix')">
                                                Terealisasi
                                                <i :class="sortKey === 'pbl_tot_budget_fix'
                                                    ? sortOrders['pbl_tot_budget_fix'] > 0
                                                        ? 'bx bx-sort-up'
                                                        : 'bx bx-sort-down'
                                                    : 'bx bx-move-vertical'
                                                    "></i>
                                            </th>
                                        </tr>
                                    </thead>
                                </DataTable>
                            </div>
                        </div>
                        <pagination :pagination="pagination" @to-page="toPage"></pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail General Information -->
        <b-modal v-model="showFeedbackPeserta" title="Feedback Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <div class="form-group mb-3">
                <label for="">Isi</label>
                <textarea name="" class="form-control" v-model="feedback_peserta" id="" cols="30" rows="10" readonly></textarea>
            </div>
        </b-modal>
    </Layout>
</template>
